import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  fetchInspectionResults,
  fetchInspectionResultssWithFilters,
  fetchInspectionResultsData,
} from './store/slice';
import { fetchParts } from '../../core/redux/part/slice';
import InspectionResultsTopHead from './inspectionresults-top-head';
import InspectionResultsContent from './inspectionresults-content';
import InspectionResultsModals from './inspectionresults-modals';
import { actions as inspectionResultsActions } from './store/slice';
import { fetchAllProcessStatuses } from '../../core/redux/status/slice';
import { parseInspectionResultsDeepLink } from './inspection-results-deep-link';

const { resetFilters, setFilterVisible, setSelectedPart, setDeepLink } = inspectionResultsActions;

const InspectionResultsView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const openedDeepLinkKeyRef = useRef(null);

  useEffect(() => {
    dispatch(fetchInspectionResultssWithFilters());
    dispatch(fetchAllProcessStatuses());
    // dispatch(fetchParts());
    return () => {
      dispatch(resetFilters());
      dispatch(setFilterVisible(false));
    };
  }, []);

  useEffect(() => {
    const deepLink = parseInspectionResultsDeepLink(location.search);
    if (!deepLink) {
      openedDeepLinkKeyRef.current = null;
      return undefined;
    }

    const key = `${deepLink.partId}:${deepLink.resultId || ''}:${deepLink.tab}:${deepLink.workTicket}`;
    if (openedDeepLinkKeyRef.current === key) {
      return undefined;
    }
    openedDeepLinkKeyRef.current = key;

    const part = { id: deepLink.partId, partId: deepLink.partId };
    dispatch(setDeepLink(deepLink));
    dispatch(setSelectedPart(part));
    dispatch(
      fetchInspectionResultsData({
        inspectionresults: part,
        pageNumber: 1,
        pageSize: 50,
      }),
    );
    return undefined;
  }, [dispatch, location.search]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Inspection Results</h4>
              </div>
            </div>
            <InspectionResultsTopHead />
          </div>
          <InspectionResultsContent />
          <InspectionResultsModals />
        </div>
      </div>
    </div>
  );
};

export default InspectionResultsView;
